import { qoriaColours } from "@/theme/colours";
import { Box } from "@chakra-ui/react";
import React from "react";

interface Props {
	active: boolean;
	hasUnreadMessages: boolean;
}

export function ChatButtonStatusIndicator(props: Props): JSX.Element {
	function getBgColour() {
		if (props.hasUnreadMessages) {
			return "#df2935";
		} else if (props.active) {
			return qoriaColours.brand.success[400];
		} else {
			return qoriaColours.brand.neutral[400];
		}
	}

	return (
		<Box
			width={4}
			height={4}
			position={"absolute"}
			top={-1.5}
			left={-1.5}
			zIndex={1}
			backgroundColor={getBgColour()}
			rounded={"full"}
			border={`1px solid ${qoriaColours.brand.neutral[10]}`}
		></Box>
	);
}
